import Vue from 'vue';
import VueRouter, { RouterOptions } from 'vue-router';
import AnnouncementList from '@/containers/pages/AnnouncementList.vue';
import AnnouncementSetting from '@/containers/pages/AnnouncementSetting.vue';
import AnnouncementWithId from '@/containers/pages/AnnouncementWithId.vue';
import CommonSetting from '@/containers/pages/CommonSetting.vue';
import EventCalendar from '@/containers/pages/EventCalendar.vue';
import EventCalendarEvent from '@/containers/pages/EventCalendarEvent.vue';
import EventCalendarEventReadOnly from '@/containers/pages/EventCalendarEventReadOnly.vue';
import EventCalendarHoliday from '@/containers/pages/EventCalendarHoliday.vue';
import EventCalendarHolidayReadOnly from '@/containers/pages/EventCalendarHolidayReadOnly.vue';
import EventList from '@/containers/pages/EventList.vue';
import GeneralSetting from '@/containers/pages/GeneralSetting.vue';
import Jobs from '@/containers/pages/Jobs.vue';
import Maintenance from '@/containers/pages/Maintenance.vue';
import OSSLicense from '@/containers/pages/OSSLicense.vue';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import Portal from '@/containers/pages/Portal.vue';
import RoleEdit from '@/containers/pages/RoleEdit.vue';
import RoleManagement from '@/containers/pages/RoleManagement.vue';
import Search from '@/containers/pages/Search.vue';
import Setting from '@/containers/pages/Setting.vue';
import SiteMap from '@/containers/pages/SiteMap.vue';
import UserManagement from '@/containers/pages/UserManagement.vue';
import WebApiSetting from '@/containers/pages/WebApiSetting.vue';
import { authenticate } from '@/router/authenticate';
import { redirect } from '@/router/guard';
import { PAGE_PATH_BY_NAME, UNDEFINED_PATH_NAME } from '@/utils/consts';

Vue.use(VueRouter);

const routes: RouterOptions['routes'] = [
  {
    path: PAGE_PATH_BY_NAME.portal,
    component: Portal,
    name: 'portal',
    beforeEnter: redirect,
  },
  {
    path: PAGE_PATH_BY_NAME.searchQuery,
    component: Search,
    name: 'searchQuery',
  },
  {
    path: PAGE_PATH_BY_NAME.setting,
    component: Setting,
    name: 'setting',
  },
  {
    path: PAGE_PATH_BY_NAME.sitemap,
    component: SiteMap,
    name: 'sitemap',
  },
  {
    path: PAGE_PATH_BY_NAME.commonsetting,
    component: CommonSetting,
    name: 'commonSetting',
    children: [
      {
        path: 'general',
        component: GeneralSetting,
        name: 'general',
      },
      {
        path: 'announcement',
        component: AnnouncementSetting,
        name: 'announcement',
      },
      {
        path: 'webApi',
        component: WebApiSetting,
        name: 'webApi',
      },
      {
        path: 'usermanagement',
        component: UserManagement,
        name: 'userManagement',
      },
      {
        path: 'roles',
        component: RoleManagement,
        name: 'roles',
      },
      {
        path: 'roles/create',
        component: RoleEdit,
        name: 'createRole',
      },
      {
        path: 'roles/edit/:id',
        component: RoleEdit,
        name: 'editRole',
      },
      {
        path: '/',
        component: GeneralSetting,
        name: 'general',
      },
    ],
  },
  {
    path: PAGE_PATH_BY_NAME.announcementWithId,
    component: AnnouncementWithId,
    name: 'announcementWithId',
  },
  {
    path: PAGE_PATH_BY_NAME.announcementList,
    component: AnnouncementList,
    name: 'announcementList',
  },
  {
    path: PAGE_PATH_BY_NAME.eventCalendar,
    component: EventCalendar,
    name: 'eventCalendar',
  },
  {
    path: PAGE_PATH_BY_NAME.eventList,
    component: EventList,
    name: 'eventList',
  },
  {
    path: PAGE_PATH_BY_NAME.jobs,
    component: Jobs,
    name: 'jobs',
  },
  {
    path: PAGE_PATH_BY_NAME.createJob,
    component: Jobs,
    name: 'createJob',
  },
  {
    path: PAGE_PATH_BY_NAME.job,
    component: Jobs,
    name: 'job',
  },
  {
    path: PAGE_PATH_BY_NAME.createHoliday,
    component: EventCalendarHoliday,
    name: 'createHoliday',
  },
  {
    path: PAGE_PATH_BY_NAME.editHoliday,
    component: EventCalendarHoliday,
    name: 'editHoliday',
  },
  {
    path: PAGE_PATH_BY_NAME.copyHoliday,
    component: EventCalendarHoliday,
    name: 'copyHoliday',
  },
  {
    path: PAGE_PATH_BY_NAME.viewHoliday,
    component: EventCalendarHolidayReadOnly,
    name: 'viewHoliday',
  },
  {
    path: PAGE_PATH_BY_NAME.createEvent,
    component: EventCalendarEvent,
    name: 'createEvent',
  },
  {
    path: PAGE_PATH_BY_NAME.editEvent,
    component: EventCalendarEvent,
    name: 'editEvent',
  },
  {
    path: PAGE_PATH_BY_NAME.copyEvent,
    component: EventCalendarEvent,
    name: 'copyEvent',
  },
  {
    path: PAGE_PATH_BY_NAME.viewEvent,
    component: EventCalendarEventReadOnly,
    name: 'viewEvent',
  },
  {
    path: PAGE_PATH_BY_NAME.maintenance,
    component: Maintenance,
    name: 'maintenance',
  },
  {
    path: PAGE_PATH_BY_NAME.OSSLicense,
    component: OSSLicense,
    name: 'OSSLicense',
  },
  {
    // Handling undefined paths. Redirect to not found page.
    path: '*',
    component: PageNotFound,
    name: UNDEFINED_PATH_NAME,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(authenticate);

export default router;
